var map = {
	"./ambassador-bg.webp": 1276,
	"./asset-2.png": 1277,
	"./btn-enter-bg.png": 1278,
	"./btn-enter-white-bg.webp": 1279,
	"./btn-more-bg.webp": 1280,
	"./casino-hover.webp": 1281,
	"./casino.webp": 1282,
	"./convenient.webp": 1283,
	"./es-bg.webp": 1284,
	"./event-sec-bg.webp": 1285,
	"./event-sport-bg.webp": 1286,
	"./fifa1-bg.jpg": 1287,
	"./fifa2-bg-cn.jpg": 1288,
	"./fifa2-bg.jpg": 1289,
	"./games-hover.webp": 1290,
	"./games.webp": 1291,
	"./gauge.webp": 1292,
	"./lottery-hover.webp": 1293,
	"./lottery.webp": 1294,
	"./master-bg.webp": 1295,
	"./p2p-hover.webp": 1296,
	"./p2p.webp": 1297,
	"./platform.webp": 1298,
	"./product-ctg-bg.webp": 1299,
	"./product-overview-bg.webp": 1300,
	"./professional.webp": 1301,
	"./safety.webp": 1302,
	"./slots-hover.webp": 1303,
	"./slots.webp": 1304,
	"./speed.webp": 1305,
	"./sports-hover.webp": 1306,
	"./sports.webp": 1307,
	"./video-bg.webp": 1308,
	"./wave.webp": 1309,
	"./wwr-bg.webp": 1310,
	"./wwr-img-b.webp": 1311,
	"./wwr-img.webp": 1312,
	"./wwr-subImg1.webp": 1313,
	"./wwr-subImg2.webp": 1314,
	"./wwr-subImg3.webp": 1315,
	"./x33-logo-cny.png": 1316
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 459;